var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { createSelector } from 'reselect';
import { initialState } from './reducer';
export var selectDataAndPrivacy = function (state) {
    return state.dataAndPrivacy || initialState;
};
export var makeDataAndPrivacyPageDomain = function () {
    return createSelector(selectDataAndPrivacy, function (pageState) { return (__assign({}, pageState)); });
};
